import { HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { isPublicAppPath } from '../../shared/Utils/public-path.utils';

/**
 * Intercepta respuestas 401 del API y redirige al login de Keycloak.
 * Cubre el caso de sesión expirada cuando checkLoginIframe está desactivado.
 * No actúa en rutas públicas donde no hay sesión esperada.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error) => {
      if (
        error?.status === HttpStatusCode.Unauthorized &&
        !isPublicAppPath()
      ) {
        authService.redirectToLogin();
      }
      return throwError(() => error);
    }),
  );
};
